import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class repeat_forever extends ASTBlock {
    constructor(color) {
        super(color, "repeat_forever")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "wiederhole forlaufend %1 %2",
            "args0": [{
                    "type": "input_dummy",
                    "name": "NAME"
                },
                {
                    "type": "input_statement",
                    "name": "statement"
                }
            ],
            "previousStatement": null,
            "inputsInline": false
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}